import React from 'react';
import ReactDOM from 'react-dom';
import { translate } from 'react-i18next';

import SidebarMultiSelectExchangeLink from 'components/ScheduleSidebar/SidebarMultiSelectExchangeLink';
import ScheduleShiftLabel from 'components/ScheduleShiftLabel';
import Popover from 'components/popover/Popover.js';
import { describeUnavailableChip } from 'components/ScheduleSidebar/unavailableRows.js';

class ScheduleDay extends React.Component {
  constructor(props) {
    super(props);

    this.onDaySelect = this.props.onDaySelect;
    this.fullDate = null;
    this._onClosePopover = this._onClosePopover.bind(this);
    this._onHandleClosePopover = this._onHandleClosePopover.bind(this);
    this._onMultiShiftDaySelect = this._onMultiShiftDaySelect.bind(this);
    this.onDaySelectClickHandler = this.onDaySelectClickHandler.bind(this);

    this.state = {
      shifts: [],
      currentDay: '',
      domSet: this.props.domSet != 'false',
      exchanged: false,
      selected: false,
      active: false,
      today: false,
      deeplink: false,
      popOverActive: false,
      popTarget: null,
      currentDayData: null,
      hasPendingRequests: false,
    };
  }

  componentWillUnmount() {
    ShiftStore.off(null, null, this);
    AvailabilitiesStore.off(null, null, this);
    ExchangesStore.off(null, null, this);
    UnavailablesStore.off(null, null, this);
    BidsStore.off(null, null, this);
    document.removeEventListener('popover:closed', this._onHandleClosePopover, this);
  }

  _onHandleClosePopover(e) {
    if (ReactDOM.findDOMNode(this).contains(e.popOver)) {
      this._onClosePopover();
    }
  }

  componentDidMount() {
    const that = this;

    document.addEventListener('popover:closed', this._onHandleClosePopover, this);

    ShiftStore.on(appConstants.ActionTypes.CLEAR_CALENDAR, () => {
      that.clearDay();
    });

    ShiftStore.on(
      'shift:deeplink',
      function (shift_id, shiftDate) {
        const domDate = this._getFullDate();
        const num = domDate.format('D');
        if (domDate.isSame(moment(shiftDate))) {
          this.onDaySelectHandler(this.props);
        }
      },
      this,
    );

    AvailabilitiesStore.on(
      'availability:delete:success',
      function (collection, response) {
        const that = this;
        that.state.domSet = false;
      },
      this,
    );

    AvailabilitiesStore.on(
      'availability:create:success',
      function (collection, response) {
        const that = this;
        that.state.domSet = false;
      },
      this,
    );

    ExchangesStore.on(
      'exchanges:post:advertisment:success',
      function (response, collection) {
        const domDate = this._getFullDate();
        const num = domDate.format('D');

        const shiftData = ShiftStore.get(response.shift_id).present();
        const responseDate = shiftData.date;
        const shiftDate = moment(responseDate);

        if (domDate.isSame(shiftDate)) {
          this.setState({
            domSet: false,
            exchanged: true,
          });
        }
      },
      this,
    );

    ExchangesStore.on(
      'exchanges:cancel:advertisment:success',
      function (collection) {
        const domDate = this._getFullDate();
        const num = domDate.format('D');

        const shiftID = !Utils.isNotDefined(collection.attributes)
          ? collection.attributes.shift_id
          : collection.id;
        let shiftData = ShiftStore.get(shiftID);

        if (!_.isUndefined(shiftData.attributes)) {
          shiftData = shiftData.present();
        }
        const responseDate = shiftData.date;
        const shiftDate = moment(responseDate);

        if (domDate.isSame(shiftDate)) {
          this.setState({
            domSet: false,
            exchanged: false,
          });
          this.forceUpdate();
        }
      },
      this,
    );

    UnavailablesStore.on(
      'unavailables:create:success',
      function (collection, id) {
        if (!Utils.isNotDefined(id)) {
          const date = this._getFullDate();
          const latest = collection.get(id).present();
          const latestDateStart = moment(latest.start_date);
          const latestDateEnd = moment(latest.end_date);
          const range = moment().range(latestDateStart.toDate(), latestDateEnd.toDate());
          this.state.active = false;

          if (range.contains(date)) {
            this.setState({ hasPendingRequests: true, active: false });
          }
        }
        const that = this;
        that.state.domSet = false;
      },
      this,
    );

    UnavailablesStore.on(
      'unavailables:cancel:success',
      function (model, response, startDate, endDate) {
        const date = this._getFullDate();
        let latestDateStart;
        let latestDateEnd;
        if (!Utils.isNotDefined(model.start_date)) {
          latestDateStart = moment(model.start_date);
          latestDateEnd = moment(model.end_date);
        } else if (!Utils.isNotDefined(startDate) && !Utils.isNotDefined(endDate)) {
          latestDateStart = moment(startDate);
          latestDateEnd = moment(endDate);
        }
        const range = moment().range(latestDateStart.toDate(), latestDateEnd.toDate());

        if (range.contains(date)) {
          if (this.state.active) {
            setTimeout(() => this.onDaySelectHandler(this.props), 500);
          }
          this.setState({ hasPendingRequests: false, active: false });
        }

        this.state.domSet = false;
      },
      this,
    );

    // Declaring / self-removing an N/A Day re-selects the active day via a
    // triggered click (ScheduleView#_updatedUnavailabilities), but
    // onDaySelectHandler ignores clicks while state.active is set. Drop
    // active/domSet the way the unavailables:create:success handler above
    // does so the re-click actually refreshes the sidebar.
    const onNaChange = function () {
      this.state.active = false;
      this.state.domSet = false;
    };
    UnavailablesStore.on('unavailables:na:create:success', onNaChange, this);
    UnavailablesStore.on('unavailables:na:remove:success', onNaChange, this);

    BidsStore.on(
      'exchanges:post:bid:drop:success',
      function (collection, response) {
        if (this.state.active) {
          // this.setState({exchanged:true});
        }
      },
      this,
    );

    BidsStore.on(
      'bids:destroy:success',
      function () {
        setTimeout(e => this.parseData(), 500);
      },
      this,
    );
  }

  _getFullDate() {
    // return this.fullDate;
    const me = ReactDOM.findDOMNode(this);
    if (!me) return null;
    return moment(ReactDOM.findDOMNode(this).getAttribute('data-full-date'));
  }

  isEmptyDay(day) {
    let bool = false;
    if (
      Utils.isNotDefined(day.availableExchanges)
      && Utils.isNotDefined(day.availableShifts)
      && Utils.isNotDefined(day.offeredShifts)
      && Utils.isNotDefined(day.scheduledShifts)
      && Utils.isNotDefined(day.unavailableRequests)
      && Utils.isNotDefined(day.unavailableShifts)
      && Utils.isNotDefined(day.shiftData)
    ) {
      bool = true;
    }

    return bool;
  }

  componentWillReceiveProps(nextProps) {
    const day = ReactDOM.findDOMNode(this).classList.contains('active');
    const deeplink = ReactDOM.findDOMNode(this).classList.contains('deeplink');
    if (!day) {
      this.state.active = false;
    }
    if (!deeplink) {
      this.state.deeplink = false;
    } else {
      this.state.deeplink = true;
      setTimeout(() => this.onDaySelectHandler(nextProps), 500);
    }
    if (this.props.dayShiftData != nextProps.dayShiftData && this.state.domSet) {
      this.state.domSet = false;
    }

    if (!nextProps.exchangeDaySelectMode || nextProps.exchangeDaySelectMode == 'false') {
      this.state.selected = false;
      this._setExchangeSelectionMode(false);
    } else {
      this._setExchangeSelectionMode(true);
    }

    this._checkIfMultiShiftsAreSelected();
  }

  _setExchangeSelectionMode(bool) {
    this.setState({
      exchangeMode: bool,
    });
  }

  componentDidUpdate() {
    const domDate = this._getFullDate();
    const num = domDate.format('D');
    if (this.state.domSet == false && domDate != null) {
      this.state.domSet = true;
      this.state.currentDay = domDate;
      if (this.state.currentDay != undefined && this.state.currentDay != '') {
        this.parseData();
      }
    }

    const date = this._getFullDate();
    const today = moment(new Date().setHours(0, 0, 0, 0));
    this.state.today = !!today.isSame(date);
  }

  _bidShiftToExchange() {
    const currentDayData = this.extractDayData();

    if (Utils.isNotDefined(currentDayData.scheduledShifts)) return false;

    const acceptedExchange = !_.isEmpty(
      ExchangesStore.getExchangeByAcceptedShiftId(currentDayData.scheduledShifts[0].id),
    );
    let selectable = true;

    if (
      !currentDayData.scheduledShifts
      || currentDayData.scheduledShifts.length == 0
      || acceptedExchange
    ) {
      selectable = false;
    }

    if (selectable) {
      if (!ReactDOM.findDOMNode(this).classList.contains('selected') && this.state.selected) {
        this.state.selected = !this.state.selected;
      }
      if (!this.state.selected) {
        ReactDOM.findDOMNode(this).classList.add('selected');
        this.state.selected = true;
      } else {
        ReactDOM.findDOMNode(this).classList.remove('selected');
        this.state.selected = false;
      }
    }
    return selectable;
  }

  _onMultiShiftDaySelect(e, shiftID) {
    const shiftData = ShiftStore.get(shiftID);
    if (!_.contains(this.props.selectedExchangeDays, shiftData)) {
      this.props.onDaySelect(
        shiftData,
        moment(ReactDOM.findDOMNode(this).getAttribute('data-full-date')).toDate(),
        true,
        ReactDOM.findDOMNode(this),
      );
      this._onClosePopover();
    }
  }

  onDaySelectClickHandler(e) {
    this.onDaySelectHandler(this.props, e);
  }

  onDaySelectHandler(data, e) {
    const exchangeable = this.exchangeable(
      this.props.selectedExchangeShift,
      this.props.dayShiftData,
      );
      if (!this.state.active || exchangeable) {
      const selected = false;
      let selectable = true;
      const dayShiftData = this.extractDayData();
      if (!this.props.exchangeDaySelectMode) {
        const days = document.querySelectorAll('.month .day');
        [].forEach.call(days, (day) => {
          day.classList.remove('active');
          day.classList.remove('selected');
        });

        ReactDOM.findDOMNode(this).classList.add('active');
        this.state.active = true;
        this.state.selected = false;
      } else {
        selectable = this.exchangeable(this.props.selectedExchangeShift, this.props.dayShiftData);

        if (selectable) {
          if (dayShiftData.scheduledShifts.length > 1) {
            const that = this;
            setTimeout(() => {
              that.setState({
                popOverActive: true,
                popTarget: ReactDOM.findDOMNode(that),
              });
            }, 250);
            selectable = false;
          }
          this._bidShiftToExchange();
        }
      }
      if (selectable) {
        this.props.onDaySelect(
          dayShiftData,
          moment(ReactDOM.findDOMNode(this).getAttribute('data-full-date')).toDate(),
          this.state.selected,
          ReactDOM.findDOMNode(this),
        );
      }
    }
    this.props.clearSelectedShiftId();
  }

  clearDay() {
    // clear state but don't setState, don't want to trigger render until new data is loaded.
    const that = this;
    React.Children.forEach(this.props.children, (el) => {
      Utils.fadeOutElements(el);
    });

    setTimeout(() => {
      that.state.shifts = [];
    }, 50);
    this.state.currentDay = '';
    this.state.domSet = false;
    this.state.exchanged = false;
    this.state.selected = false;
    this.state.active = false;
    this.state.today = false;
    this.state.deeplink = false;
  }

  extractDayData() {
    const that = this;
    const isCurrent = ReactDOM.findDOMNode(this).getAttribute('data-month') === 'current';
    const date = this._getFullDate();
    const num = date.format('D');
    this.state.currentDayData = [];

    if (isCurrent && !Utils.isNotDefined(that.props.dayShiftData)) {
      this.state.currentDayData = {
        scheduledShifts: that.props.dayShiftData.scheduledShifts,
        offeredShifts: that.props.dayShiftData.offeredShifts,
        availableExchanges: that.props.dayShiftData.availableExchanges,
        availableShifts: that.props.dayShiftData.availableShifts,
        unavailableShifts: that.props.dayShiftData.unavailableShifts,
        unavailableRequests: that.props.dayShiftData.unavailableRequests,
        selectedShift: that.props.selectedShift,
      };
    }

    return this.state.currentDayData;
  }

  hasActiveExchange(data) {
    let bool = false;
    if (typeof data === 'undefined') {
      return false;
    }
    const len = data.length;
    for (let i = 0; i < len; i++) {
      if (data[i].state !== 'approved' && data[i].state !== 'rejected' && data[i].state !== 'new') {
        bool = true;
        break;
      }
    }
    return bool;
  }

  parseData() {
    let startTime;
    const isCurrent = ReactDOM.findDOMNode(this).getAttribute('data-month') === 'current';
    const that = this;

    const date = this._getFullDate();
    const iso = parseInt(date.unix(), 10);
    const maxCount = 3;
    var hasPendingRequests = false;

    const dayShiftData = this.extractDayData();
    if (isCurrent && !Utils.isNotDefined(that.props.dayShiftData)) {
      // now with less looping. Week data with objects keyed with exact day allow for specific data plucking.
      let scheduledShifts = [];

      // sort the shifts by start time
      const shiftDayData = _.sortBy(dayShiftData.scheduledShifts, shift => shift.start_time);

      let exchangeStateSet = false;
      if (!Utils.isNotDefined(shiftDayData)) {
        var len = !Utils.isNotDefined(shiftDayData) ? shiftDayData.length : 0;
        for (var i = 0; i < len; i++) {
          var checkDate = moment(shiftDayData[i].date).toDate();
          if (this.isDay(date, checkDate)) {
            var acceptedExchange = !_.isEmpty(
              ExchangesStore.getExchangeByAcceptedShiftId(shiftDayData[i].id),
            );
            startTime = Utils.formatTimeString(
              moment(shiftDayData[i].start_time)
                .tz(shiftDayData[i].time_zone)
                .format('h:mm a'),
            );
            var endTime = Utils.formatTimeString(
              moment(shiftDayData[i].end_time)
                .tz(shiftDayData[i].time_zone)
                .format('h:mm a'),
            );
            const hideEnd = shiftDayData[i].hide_end_time;
            scheduledShifts.push(
              <ScheduleShiftLabel
                type="scheduled"
                acceptedExchange={acceptedExchange}
                label={`${startTime} – ${!hideEnd ? endTime : this.props.t('ScheduleDay.tbd')}`}
                key={`scheduled-${iso * 1}${i}`}
              />,
            );
          }
          if (!exchangeStateSet) {
            var isBeforeToday = moment(shiftDayData[i].date).isBefore(moment(Date.now()));
            var activeExchange = this.hasActiveExchange(shiftDayData[i].exchanges);
            if ((activeExchange && !isBeforeToday) || acceptedExchange) {
              this.setState({ exchanged: true });
              exchangeStateSet = true;
            } else {
              this.setState({ exchanged: false });
            }
          }
        }
      }

      const offeredDayData = dayShiftData.offeredShifts;
      if (!Utils.isNotDefined(offeredDayData)) {
        var len = !Utils.isNotDefined(offeredDayData) && !Utils.isNotDefined(offeredDayData.length)
          ? offeredDayData.length
          : 0;
        for (var i = 0; i < len; i++) {
          if (this.props.selectedShift == offeredDayData[i].id) {
            setTimeout(() => {
              this.onDaySelectHandler(this.props);
            }, 1000);
            break;
          }
        }
        let offeredLabel = `${len} ${this.props.t('ScheduleDay.available')}`;
        scheduledShifts.push(
          <ScheduleShiftLabel
            type="available"
            label={offeredLabel}
            key={`available-${iso * 2}${len}`}
          />,
        );
      }

      const exchangeDayData = dayShiftData.availableExchanges;
      if (!Utils.isNotDefined(exchangeDayData)) {
        var len = !Utils.isNotDefined(exchangeDayData) ? exchangeDayData.length : 0;
        let count = 0;
        let lastDate = moment(Date.now());
        // this.state.exchanged = false;
        for (var i = 0; i < len; i++) {
          const compareDate = moment(exchangeDayData[i].shift_details.date).toDate();
          var activeExchange = this.hasActiveExchange(exchangeDayData[i].shift_details.exchanges);
          var isBeforeToday = moment(compareDate).isBefore(moment(Date.now()));
          const iHaveBidded = BidsStore.iHazBidz(exchangeDayData[i]);
          if (
            activeExchange
            && !isBeforeToday
            && iHaveBidded
            && exchangeDayData[i].state == 'accepted'
          ) {
            this.setState({
              exchanged: true,
            });
          }

          if (this._checkForExchangeOverlap(exchangeDayData[i], dayShiftData.scheduledShifts)) {
            if (this.isDay(date, compareDate) && exchangeDayData[i].state != 'accepted') {
              lastDate = moment(exchangeDayData[i].shift_details.start_time).tz(
                exchangeDayData[i].shift_details.time_zone,
              );
              count++;
            }
          }
        }
        let exchangeLabel = `${count} ${this.props.t('ScheduleDay.exchange')}`;
        if (count > 1) {
          exchangeLabel = `${count} ${this.props.t('ScheduleDay.exchanges')}`;
        }
        if (count > 0) {
          const key = lastDate.unix() * 3 + count;
          scheduledShifts.push(
            <ScheduleShiftLabel type="exchange" label={exchangeLabel} key={`exchange-${key}`} />,
          );
        }
      } else if (!exchangeStateSet) {
        this.setState({
          exchanged: false,
        });
      }

      const availableDayData = dayShiftData.availableShifts;
      const availableShifts = [];
      if (!Utils.isNotDefined(availableDayData)) {
        var len = !Utils.isNotDefined(availableDayData) ? availableDayData.length : 0;
        for (var i = 0; i < len; i++) {
          const compare = moment(
            moment
              .tz(moment.unix(availableDayData[i].starts_at), Utils.getCoreUser().inferred_time_zone)
              .format('YYYY-MM-DD'),
          ).toDate();

          if (this.isDay(date, compare)) {
            startTime = Utils.formatTimeString(
              moment
                .unix(availableDayData[i].starts_at)
                .tz(Utils.getCoreUser().inferred_time_zone)
                .format('h:mm a'),
            );

            var endTime = Utils.formatTimeString(
              moment
                .unix(availableDayData[i].ends_at)
                .tz(Utils.getCoreUser().inferred_time_zone)
                .format('h:mm a'),
            );

            let shiftLabel = `${startTime} – ${endTime}`;
            if (shiftLabel == '12a – 12a') {
              shiftLabel = this.props.t('ScheduleDay.all_day');
            }
            scheduledShifts.push(
              <ScheduleShiftLabel
                type="assigned"
                label={shiftLabel}
                key={`assigned-${availableDayData[i].id}`}
              />,
            );
          }
        }
      }

      const unavailableDayData = dayShiftData.unavailableShifts;
      var hasPendingRequests = false;

      if (!Utils.isNotDefined(unavailableDayData)) {
        var len = !Utils.isNotDefined(unavailableDayData) ? unavailableDayData.length : 0;
        for (let _i = 0; _i < len; _i++) {
          const unavailable = unavailableDayData[_i];

          if (!Utils.isNotDefined(unavailable.unavailable_request_id)) {
            const request = UnavailablesStore.getAllUnavailableRequestsById(
              unavailable.unavailable_request_id,
            );

            // If the unavailable belongs to a reuqest, check
            // if it's a pending one. If so skip the rest since
            // we only display an asterisk *
            if (request.state == 'new') {
              hasPendingRequests = true;
              continue;
            }
          }

          var checkDate = moment(unavailable.date).toDate();
          const unStartDate = moment(checkDate);
          const unEndDate = moment(checkDate);
          const range = moment().range(unStartDate.toDate(), unEndDate.toDate());

          if (range.contains(date)) {
            // If this point has been reached, we can assume that the unavailable is not an unavailable request
            scheduledShifts.push(
              <ScheduleShiftLabel
                startTime={startTime}
                {...describeUnavailableChip(unavailable, this.props.t)}
                key={`${unavailable.id}-${iso * 5}${_i}`}
              />,
            );
          }
        }
      }

      if (scheduledShifts.length > maxCount) {
        const moreLabel = `+${scheduledShifts.length - maxCount + 1} ${this.props.t('ScheduleDay.more')}`;

        scheduledShifts = scheduledShifts.slice(0, maxCount - 1);
        scheduledShifts.push(
          <ScheduleShiftLabel
            startTime={startTime}
            type="more"
            label={moreLabel}
            key={`more-${iso * 6}`}
          />,
        );
      }

      this.setState({
        shifts: scheduledShifts,
        hasPendingRequests,
      });
    }

    if (isCurrent) {
      const myExchange = ExchangesStore.getMyAcceptedShiftExchangesByDate(date);
      if (!Utils.isNotDefined(myExchange)) {
        this.setState({
          exchanged: true,
        });
      }
    }
  }

  _checkForExchangeOverlap(exchange, shifts) {
    if (_.isEmpty(shifts) || exchange.drop) {
      return true;
    }
    const len = shifts.length;
    let valid = true;
    let count = 0;
    if (len > 1 && !exchange.drop) {
      for (let i = 0; i < len; i++) {
        const shift = shifts[i];
        const selectedShiftStart = moment(shift.start_time).tz(shift.time_zone);
        const selectedShiftEnd = moment(shift.end_time).tz(shift.time_zone);
        const exchangerStart = moment(exchange.shift_details.start_time).tz(
          exchange.shift_details.time_zone,
        );
        const exchangerEnd = moment(exchange.shift_details.end_time).tz(
          exchange.shift_details.time_zone,
        );
        const isBetween = moment(selectedShiftStart).isBetween(exchangerStart, exchangerEnd)
          || moment(selectedShiftEnd).isBetween(exchangerStart, exchangerEnd)
          || (moment(selectedShiftStart).isSame(exchangerStart)
            && moment(selectedShiftEnd).isSame(exchangerEnd));

        if (isBetween) {
          count++;
        }
      }
    }
    if (count > 1) {
      valid = false;
    }
    return valid;
  }

  isDay(day, compare) {
    let bool = false;
    const checkDay = moment(day.toDate(), 'YYYY/MM/DD').format('YYYY/MM/DD');
    const checkCompare = moment(compare, 'YYYY/MM/DD').format('YYYY/MM/DD');
    if (checkDay == checkCompare) {
      bool = true;
    }
    return bool;
  }

  exchangeable(exchanger, exchangee) {
    let valid = false;

    if (_.isNull(exchanger) || _.isEmpty(exchangee)) {
      return valid;
    }
    // check if exchangeable shifts are in the same department
    if (!_.isUndefined(exchanger.shift_details) && exchanger.shift_details.department_id) {
      const any = _.some(
        exchangee.scheduledShifts,
        shift => shift.department_id == exchanger.shift_details.department_id,
      );

      valid = any;
    }

    // check to see if shift is in current exchange
    if (valid) {
      const isExchanged = _.some(exchangee.scheduledShifts, (shift) => {
        const validExchange = Utils.getFirstActiveExchange(shift.exchanges);
        return (
          validExchange != null
          && (validExchange.state == 'accepted' || validExchange.state == 'rejected')
        );
      });

      valid = !isExchanged;
    }

    // check to see if current shift is already bid in a different exchange.
    if (valid) {
      const isBidWith = _.some(
        exchangee.scheduledShifts,
        shift => !_.isEmpty(ExchangesStore.getExchangeByAcceptedShiftId(shift.id)),
      );

      valid = !isBidWith;
    }

    // if all other checks are good, make sure shift isn't in the past.
    if (valid) {
      const isBeforeToday = _.some(exchangee.scheduledShifts, shift => moment(shift.start_time).isBefore(moment(Date.now())));

      valid = !isBeforeToday;
    }

    // check for overlapping shifts on the selected day.
    // if an overlapping day exists only allow overlapping shift
    // to be selectable for exchange.
    if (valid && !_.isEmpty(exchangee) && !_.isEmpty(exchangee.scheduledShifts)) {
      const selectedDay = ShiftStore.getShiftsByDate(
        moment(this.props.selectedExchangeShift.shift_details.start_time),
      );
      if (selectedDay.length > 0) {
        for (let i = 0; i < selectedDay.length; i++) {
          const selectedShiftStart = moment(selectedDay[i].start_time).tz(selectedDay[i].time_zone);
          const selectedShiftEnd = moment(selectedDay[i].end_time).tz(selectedDay[i].time_zone);
          const exchangerStart = moment(exchanger.shift_details.start_time).tz(
            exchanger.shift_details.time_zone,
          );
          const exchangerEnd = moment(exchanger.shift_details.end_time).tz(
            exchanger.shift_details.time_zone,
          );
          const exchangeeDay = moment(exchangee.scheduledShifts[0].start_time)
            .tz(exchangee.scheduledShifts[0].time_zone)
            .format('D');
          const exchangerDay = moment(exchanger.shift_details.start_time)
            .tz(exchanger.shift_details.time_zone)
            .format('D');
          const isBetween = moment(selectedShiftStart).isBetween(exchangerStart, exchangerEnd)
            || moment(selectedShiftEnd).isBetween(exchangerStart, exchangerEnd)
            || (moment(selectedShiftStart).isSame(exchangerStart)
              && moment(selectedShiftEnd).isSame(exchangerEnd));

          if (valid && !_.isEmpty(exchangee) && isBetween && exchangeeDay != exchangerDay) {
            valid = false;
          }
        }
      }
    }

    return valid;
  }

  _onClosePopover() {
    this.setState({
      popOverActive: false,
      popTarget: null,
    });

    this._checkIfMultiShiftsAreSelected();
  }

  _checkIfMultiShiftsAreSelected() {
    if (
      !Utils.isNotDefined(this.state.currentDayData)
      && !Utils.isNotDefined(this.state.currentDayData.scheduledShifts)
    ) {
      ReactDOM.findDOMNode(this).classList.add('selected');
      this.state.selected = true;

      let found = false;

      const dayShiftData = this.state.currentDayData;
      const len = dayShiftData.scheduledShifts.length;
      for (let i = 0; i < len; i++) {
        if (this._isShiftAlreadySelected(dayShiftData.scheduledShifts[i])) {
          found = true;
          break;
        }
      }
      if (!found) {
        ReactDOM.findDOMNode(this).classList.remove('selected');
        this.state.selected = false;
      }
    }
  }

  _isShiftAlreadySelected(shift) {
    const len = Utils.isNotDefined(this.props.selectedExchangeDays)
      ? 0
      : this.props.selectedExchangeDays.length;
    let exists = false;
    for (let i = 0; i < len; i++) {
      if (this.props.selectedExchangeDays[i].data.id == shift.id) {
        exists = true;
        break;
      }
    }
    return exists;
  }

  _createMultiShiftSelectPopover() {
    const multiSelectShifts = [];
    if (
      !Utils.isNotDefined(this.state.currentDayData)
      && !Utils.isNotDefined(this.state.currentDayData.scheduledShifts)
    ) {
      const dayShiftData = this.state.currentDayData;
      const len = dayShiftData.scheduledShifts.length;
      const that = this;
      for (let i = 0; i < len; i++) {
        if (!this._isShiftAlreadySelected(dayShiftData.scheduledShifts[i])) {
          const checkObj = {
            scheduledShifts: [dayShiftData.scheduledShifts[i]],
          };
          if (this.exchangeable(this.props.selectedExchangeShift, checkObj)) {
            const startTime = moment(dayShiftData.scheduledShifts[i].start_time)
              .tz(dayShiftData.scheduledShifts[i].time_zone)
              .format('h:mm a');
            const endTime = moment(dayShiftData.scheduledShifts[i].end_time)
              .tz(dayShiftData.scheduledShifts[i].time_zone)
              .format('h:mm a');

            multiSelectShifts.push(
              <SidebarMultiSelectExchangeLink
                selectedShift={dayShiftData.scheduledShifts[i]}
                shiftID={dayShiftData.scheduledShifts[i].id}
                key={dayShiftData.scheduledShifts[i].id}
                startTime={startTime}
                endTime={endTime}
                replied={dayShiftData.scheduledShifts[i].replied}
                onClickHandler={this._onMultiShiftDaySelect}
              />,
            );
          }
        }
      }
    }
    return multiSelectShifts;
  }

  render() {
    // `classnames` library can be used here for a future refactor
    let classNames = this.state.exchanged ? 'day exchanged' : 'day';
    classNames = this.state.hasPendingRequests ? `${classNames} requested` : classNames;
    classNames = this.state.active ? `${classNames} active` : classNames;
    classNames = this.state.selected ? `${classNames} selected` : classNames;
    classNames = this.state.today ? `${classNames} today` : classNames;
    classNames = this.state.exchangeMode ? `${classNames} exchangeMode` : classNames;

    const multiSelectShifts = this._createMultiShiftSelectPopover();
    let popoverPos = 'top';
    if (this.props.weekCount > 3) {
      popoverPos = 'bottom';
    }

    let exchangeable = false;
    if (this.state.exchangeMode) {
      exchangeable = this.exchangeable(this.props.selectedExchangeShift, this.props.dayShiftData);
    }

    if (exchangeable) classNames += ' exchangeable';

    return (
      <div
        className={classNames}
        data-month={this.props.monthState}
        onClick={this.onDaySelectClickHandler}
      >
        {this.state.shifts}
        <Popover
          active={this.state.popOverActive}
          className="multi-shift-selector"
          position={popoverPos}
          popTarget={this.state.popTarget}
          onHide={e => this._onClosePopover(e)}
        >
          <h3 className="still-available">{this.props.t('ScheduleDay.choose_a_shift')}</h3>
          <ul>{multiSelectShifts}</ul>
          <div className="btn-group pull--right">
            <button
              className="button button--inline"
              id="multi-select-cancel-button"
              type="button"
              onClick={this._onClosePopover}
            >
              {this.props.t('ScheduleDay.cancel')}
            </button>
          </div>
        </Popover>
      </div>
    );
  }
}

export default translate()(ScheduleDay);
